import React, { useState } from "react";
import { Button } from "../../../../../components";
import {
  FormTextInput,
  FormSelect,
  FormHiddenInput,
  useFormContext,
} from "../../../../../features/auto-form";
import {
  FormHiddenDeparturePicker,
  FormHiddenDestinationSelector,
  FormHiddenCombiCalendar,
} from "../../../../../modules/custom-form-modules";
import { useTranslate } from "../../../../../features/translation/hooks/use-translation";
import DEPARTURE_AIRPORTS from "../data/se-departure-airports.json";
import PACKAGE_DESTINATIONS from "../data/package-destinations.json";
import CUSTOMER_OPTIONS from "../data/customer-options.json";
import PURPOSE_OPTIONS from "../data/purpose-options.json";
import PACKAGE_DURATION_OPTIONS from "../data/package-duration-options.json";

const PackageSearch = ({ market, onCustomerTypeChange }) => {
  const [displayCustomerOther, setDisplayCustomerOther] = useState(false);
  const [displayPurposeOther, setDisplayPurposeOther] = useState(false);
  const [displayCustomDuration, setDisplayCustomDuration] = useState(false);
  const [purposeOptions, setPurposeOptions] = useState([]);

  const { resetRefValue } = useFormContext();
  const { t } = useTranslate();


  const reset = () => {
    resetRefValue("request.customerType");
    resetRefValue("request.customerPurpose");
    resetRefValue("request.departureAirports");
    resetRefValue("request.destinations");
    resetRefValue("request.dates.departure");
    resetRefValue("request.dates.departure.end");
    resetRefValue("request.dates.departure.start");
    resetRefValue("request.dates.duration");

    setDisplayCustomerOther(false);
    setDisplayPurposeOther(false);
    setDisplayCustomDuration(false);
  };

  const handleCustomerChange = (e) => {
    const { value } = e.target;
    
    if (value === "other") {
      setDisplayCustomerOther(true);
    } else {
      setDisplayCustomerOther(false);
    }
  
    if (value) {
      setPurposeOptions(PURPOSE_OPTIONS[value]);
    } else {
      setPurposeOptions([]);
    }
  
    resetRefValue("request.customerPurpose");
    setDisplayPurposeOther(false);
  };

  const handleCustomerTypeChange = (customerTypeValue) => {
    if (onCustomerTypeChange) {
      onCustomerTypeChange(customerTypeValue);
    }
  };

  
  const handleDurationChange = (e) => {
    const { value } = e.target;
    if (value === "other") {
      setDisplayCustomDuration(true);
    } else {
      setDisplayCustomDuration(false);
    }
  };

  return (
    <div className="container" style={{ padding: "0", margin: "0" }}>
      <FormHiddenInput name="request.product.type" value="package" />
      <div className="row">
        <div className="col col-12 col-sm-6 col-md-3">
          <FormSelect
            name="request.customerType"
            languagesection="form.packageSearch.customerType"
            options={CUSTOMER_OPTIONS}
            onValueChange={handleCustomerTypeChange}
            onChange={handleCustomerChange}
            required
          />
        </div>
        {displayCustomerOther && (
          <div className="col col-12 col-sm-6 col-md-3">
            <FormTextInput
              name="request.customerTypeOther"
              languagesection="form.packageSearch.customerType.options.other"
              required
            />
          </div>
        )}

        <div className="col col-12 col-sm-6 col-md-3">
          <FormSelect
            name="request.customerPurpose"
            languagesection="form.packageSearch.customerPurposes"
            options={purposeOptions}
            onChange={(e) => {
              if (e.target.value === "other") {
                setDisplayPurposeOther(true);
              } else {
                setDisplayPurposeOther(false);
              }
            }}
            required
          />
        </div>
        {displayPurposeOther && (
          <div className="col col-12 col-sm-6 col-md-3">
            <FormTextInput
              name="request.customerPurposeOther"
              languagesection="form.packageSearch.customerPurposes.options.other"
              required
            />
          </div>
        )}
      </div>
      <div className="row">
        <div className="col col-12 col-sm-6 col-md-3">
          <FormHiddenDeparturePicker
            name="request.departureAirports"
            options={DEPARTURE_AIRPORTS}
            market={market}
            icon="aircraft-up"
            required
          />
        </div>
        <div className="col col-12 col-sm-6 col-md-3">
          <FormHiddenDestinationSelector
            name="request.destinations"
            options={PACKAGE_DESTINATIONS}
            market={market} //TODO: set market here dynamically
            icon="map"
            required
          />
        </div>

        <div className="col col-12 col-sm-6 col-md-3">
          <FormHiddenCombiCalendar
            name="request.dates"
            id="request.dates"
            icon="calendar"
            market={market}
            required
          />
        </div>
        <div className="col col-12 col-sm-6 col-md-3">
          <FormSelect
            name="request.dates.duration"
            languagesection="form.packageSearch.durations"
            options={PACKAGE_DURATION_OPTIONS}
            onChange={handleDurationChange}
            required
          />

          {displayCustomDuration && (
            <FormTextInput
              name="request.dates.durationCustom"
              languagesection="form.packageSearch.customDuration"
              required
            />
          )}
        </div>
      </div>

      <div className="row">
        <div
          className="col col-12"
          style={{ display: "flex", justifyContent: "end" }}
        >
          <Button
            label={t("input.button.resetFields")}
            className="ghost medium"
            style={{ border: 0, textDecoration: "underline", zIndex: 1 }}
            onClick={reset}
          />
        </div>
      </div>
    </div>
  );
};

export default PackageSearch;
